/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_LiveInputs */

const th_status_live = /** @type {(inputs: Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังแข่ง`)
};

const en_status_live = /** @type {(inputs: Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live now`)
};

const ja_status_live = /** @type {(inputs: Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`試合中`)
};

const zh_status_live = /** @type {(inputs: Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`直播中`)
};

const es_status_live = /** @type {(inputs: Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En directo`)
};

const pt_status_live = /** @type {(inputs: Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ao vivo`)
};

const id_status_live = /** @type {(inputs: Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langsung`)
};

const fr_status_live = /** @type {(inputs: Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En direct`)
};

const tl_status_live = /** @type {(inputs: Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live`)
};

const vi_status_live = /** @type {(inputs: Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trực tiếp`)
};

const ko_status_live = /** @type {(inputs: Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`실시간`)
};

const de_status_live = /** @type {(inputs: Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live`)
};

const ru_status_live = /** @type {(inputs: Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В эфире`)
};

const tr_status_live = /** @type {(inputs: Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canlı`)
};

const it_status_live = /** @type {(inputs: Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In diretta`)
};

const pl_status_live = /** @type {(inputs: Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na żywo`)
};

const uk_status_live = /** @type {(inputs: Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В ефірі`)
};

const hi_status_live = /** @type {(inputs: Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लाइव`)
};

const ar_status_live = /** @type {(inputs: Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مباشر`)
};

const ms_status_live = /** @type {(inputs: Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langsung`)
};

const bn_status_live = /** @type {(inputs: Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সরাসরি`)
};

const zh_tw2_status_live = /** @type {(inputs: Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`直播中`)
};

const zh_hk2_status_live = /** @type {(inputs: Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`直播中`)
};

const ur_status_live = /** @type {(inputs: Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`براہ راست`)
};

const fa_status_live = /** @type {(inputs: Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`زنده`)
};

const sw_status_live = /** @type {(inputs: Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moja kwa moja`)
};

const nl_status_live = /** @type {(inputs: Status_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live`)
};

/**
* | output |
* | --- |
* | "Live now" |
*
* @param {Status_LiveInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const status_live = /** @type {((inputs?: Status_LiveInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_LiveInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_status_live(inputs)
	if (locale === "ja") return ja_status_live(inputs)
	if (locale === "zh") return zh_status_live(inputs)
	if (locale === "es") return es_status_live(inputs)
	if (locale === "pt") return pt_status_live(inputs)
	if (locale === "id") return id_status_live(inputs)
	if (locale === "fr") return fr_status_live(inputs)
	if (locale === "tl") return tl_status_live(inputs)
	if (locale === "vi") return vi_status_live(inputs)
	if (locale === "ko") return ko_status_live(inputs)
	if (locale === "de") return de_status_live(inputs)
	if (locale === "ru") return ru_status_live(inputs)
	if (locale === "tr") return tr_status_live(inputs)
	if (locale === "it") return it_status_live(inputs)
	if (locale === "pl") return pl_status_live(inputs)
	if (locale === "uk") return uk_status_live(inputs)
	if (locale === "hi") return hi_status_live(inputs)
	if (locale === "ar") return ar_status_live(inputs)
	if (locale === "ms") return ms_status_live(inputs)
	if (locale === "bn") return bn_status_live(inputs)
	if (locale === "zh-TW") return zh_tw2_status_live(inputs)
	if (locale === "zh-HK") return zh_hk2_status_live(inputs)
	if (locale === "ur") return ur_status_live(inputs)
	if (locale === "fa") return fa_status_live(inputs)
	if (locale === "sw") return sw_status_live(inputs)
	if (locale === "nl") return nl_status_live(inputs)
	return en_status_live(inputs)
});